import React, { FC, useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'
import classnames from 'classnames'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import { EffectCards, Pagination, Autoplay, Navigation } from 'swiper'
import styles from './index.module.scss'
import 'swiper/css'
import 'swiper/css/effect-cards'
import lottie from 'lottie-web'
import Arrow from './arrow.json'

type CardSwiperProps = {
  data: any
  show?: boolean
  onPageIndex: (pageIndex: number) => void
  replay?: boolean
  timeList?: object
  type?: string
}

const MySwiper: FC<CardSwiperProps> = (props) => {
  const { data, show, onPageIndex, timeList, type } = props
  const [list, setList] = useState(data)
  const [pageIndex, setPageIndex] = useState(0)

  // @ts-ignore
  // 单位为秒 -> 毫秒，*1000
  const [curTime, setCurTime] = useState(timeList.page1 * 1000)

  const ref: any = useRef()

  useEffect(() => {
    setList(data)
  }, [data])

  // useEffect(() => {
  //   if (replay) {
  //     ref.current?.swiper?.autoplay?.start()
  //   }
  // }, [replay])

  useEffect(() => {
    lottie.loadAnimation({
      animationData: Arrow,
      loop: true,
      autoplay: true,
      renderer: 'svg',
      // @ts-ignore
      container: document.getElementById('arrowLottie'),
    })
  }, [])

  return (
    <div
      id="mySwiper"
      className={classnames(
        styles.mySwiper,
        show ? styles.show : styles.hidden,
        pageIndex === list.length - 1 ? styles.lastPage : '',
        type === 'monthly' ? styles.monthly : ''
      )}
    >
      <Swiper
        ref={ref}
        slidesPerView={'auto'}
        autoplay={{ disableOnInteraction: false, delay: 5000 }}
        onSlideChange={(swiper) => {
          if (swiper.realIndex == swiper.slides.length - 1) {
            ref.current?.swiper?.autoplay?.stop()
          } else {
            // @ts-ignore
            setCurTime(timeList[`page${swiper.realIndex + 1}`] * 1000)
          }

          setPageIndex(swiper.realIndex)
          onPageIndex(swiper.realIndex)
        }}
        centeredSlides={true}
        pagination={{
          clickable: true,
          // el: '.swiper-pagination',
          // type: 'progressbar',
        }}
        navigation={{ nextEl: '.arrow-right', prevEl: '.arrow-left' }}
        // modules={[Pagination, EffectCards, Navigation]}
        modules={[Pagination, Autoplay, EffectCards, Navigation]}
        className="mySwiper"
      >
        {/* @ts-ignore */}
        {list.map((item, index) => (
          <SwiperSlide
            key={index}
            /* @ts-ignore */
            data-swiper-autoplay={curTime}
          >
            {item}
          </SwiperSlide>
        ))}
      </Swiper>

      <div className={styles.prev}>
        <div className="arrow-left arrow"></div>
      </div>
      <div className={styles.next}>
        <div className="arrow-right arrow">
          <div
            id="arrowLottie"
            className={styles.arrowLottie}
            style={{
              display:
                pageIndex === list.length - 1 || !show ? 'none' : 'block',
            }}
          ></div>
        </div>
      </div>
      {/* <div className="swiper-pagination"></div> */}
    </div>
  )
}
export default MySwiper
